/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Contains the result of the eligibility check
 * @export
 * @interface FeatureEligibility
 */
export interface FeatureEligibility {
    /**
     * the name of the feature
     * @type {string}
     * @memberof FeatureEligibility
     */
    feature?: string;
    /**
     * description of the feature
     * @type {string}
     * @memberof FeatureEligibility
     */
    description?: string;
    /**
     * shows if is eligible or not
     * @type {boolean}
     * @memberof FeatureEligibility
     */
    isEligible?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FeatureEligibility
     */
    messages?: Array<string>;
}

/**
 * Check if a given object implements the FeatureEligibility interface.
 */
export function instanceOfFeatureEligibility(value: object): value is FeatureEligibility {
    return true;
}

export function FeatureEligibilityFromJSON(json: any): FeatureEligibility {
    return FeatureEligibilityFromJSONTyped(json, false);
}

export function FeatureEligibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureEligibility {
    if (json == null) {
        return json;
    }
    return {
        
        'feature': json['feature'] == null ? undefined : json['feature'],
        'description': json['description'] == null ? undefined : json['description'],
        'isEligible': json['isEligible'] == null ? undefined : json['isEligible'],
        'messages': json['messages'] == null ? undefined : json['messages'],
    };
}

export function FeatureEligibilityToJSON(json: any): FeatureEligibility {
    return FeatureEligibilityToJSONTyped(json, false);
}

export function FeatureEligibilityToJSONTyped(value?: FeatureEligibility | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feature': value['feature'],
        'description': value['description'],
        'isEligible': value['isEligible'],
        'messages': value['messages'],
    };
}

